export const ContactDetailsWizardState = _ => ({})
